import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

const rolesRoutes = {
  admin: [], // Admin tidak dibatasi, semua path bisa diakses
  siswa: [
    '/app/data/guru',
    '/app/data/industri',
    '/app/data/orangtua',
    '/app/settings-team',
    '/app/calendar',
    '/app/data-kejuruan',
    '/app/data-kelas',
  ],
  guru: [
    '/app/data/guru',
    '/app/data/industri',
    '/app/data/orangtua',
    '/app/settings-team',
    '/app/calendar',
    '/app/data-kejuruan',
    '/app/data-kelas',
    '/app/data/siswa/tambah',
    '/app/data/siswa/edit/:id',
  ],
  orangtua: [
    '/app/data/guru',
    '/app/data/industri',
    '/app/data/siswa',
    '/app/data/orangtua',
    '/app/settings-team',
    '/app/calendar',
    '/app/data-kejuruan',
    '/app/data-kelas',
  ],
  industri: [
    '/app/data/guru',
    '/app/data/industri',
    '/app/data/orangtua',
    '/app/settings-team',
    '/app/calendar',
    '/app/data-kejuruan',
    '/app/data-kelas',
  ],
  pembimbing: [
    '/app/data/guru',
    '/app/data/industri',
    '/app/data/orangtua',
    '/app/settings-team',
    '/app/calendar',
    '/app/data-kejuruan',
    '/app/data-kelas',
    '/app/data/siswa/tambah',
    '/app/data/siswa/edit/:id',
  ],
};

const PrivateRoutes = ({ children }) => {
  const location = useLocation();
  const user = Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null;
  const userRole = user?.roles;

  const isAuthorized = (path) => {
    if (!userRole) return false;

    const blockedPaths = rolesRoutes[userRole] || [];
    
    // Admin tidak ada blocked paths, izinkan semua
    if (userRole === 'admin') return true;

    // Cek apakah path termasuk yang diblokir
    const isBlocked = blockedPaths.some(blockedPath => {
      // Support dynamic routes seperti /app/data/siswa/edit/:id
      const pattern = blockedPath.replace(/:\w+/g, '[^/]+');
      const regex = new RegExp(`^${pattern}$`);
      return regex.test(path);
    });

    // Return TRUE jika TIDAK diblokir
    return !isBlocked;
  };

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (!isAuthorized(location.pathname)) {
    return <Navigate to="/403" replace />;
  }

  return children;
};

export default PrivateRoutes;